'use strict';
const goldAsset = require('./gold-asset');
module.exports = function GoldAttachmentPacker(resourceManager, pageState) {
	const self = this;
	if (!resourceManager || !pageState) {
		throw 'invalid-args';
	}
	self.pack = (ideaArray) => {
		ideaArray.forEach((idea) => {
			const attachment = idea && idea.attr && idea.attr.attachment,
				fileId = pageState.getFileId();
			if (attachment && attachment.goldAssetId) {
				attachment.content = goldAsset.metadataForGoldAsset(attachment.goldAssetId, fileId, resourceManager.getResource(attachment.goldAssetId));
				delete attachment.goldAssetId;
			}
		});
	};
};
